import { AutoCompleteMulti, ISelectType, useFetch } from "@4uhub/lib4uhub";
import { memo, useCallback, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Grid } from "@mui/material";
import { getInsuranceTypesList } from "../../../../../../services/tasyInsuranceType.service";

const translationPath = "4uESign.page.automations.automationRules.";

export const AttendaceTypeAutoComplete = memo(() => {
  const { t } = useTranslation();
  const [insuranceTypes, setInsuranceTypes] = useState<ISelectType[]>([]);
  const [searchBy, setSearchBy] = useState<string>("");
  const { sendRequest: getInsuranceTypesListReq } = useFetch(
    getInsuranceTypesList,
  );

  const handleFetchInsuranceTypes = useCallback(async () => {
    const { data, success } = await getInsuranceTypesListReq({
      SearchBy: searchBy,
      Identifier: 12,
    });
    if (success && data) {
      const mappedItems: ISelectType[] = data.map((item) => {
        return {
          id: item.identifierValue,
          name: item.domainValueName,
          code: item.identifierValue,
        };
      });
      setInsuranceTypes(mappedItems);
    }
  }, [getInsuranceTypesListReq, searchBy]);

  useEffect(() => {
    handleFetchInsuranceTypes();
  }, [handleFetchInsuranceTypes]);

  const handleSetSearchBy = useCallback((search: string) => {
    setSearchBy(search);
  }, []);

  return (
    <Grid item xs={12} sm={12}>
      <AutoCompleteMulti
        name="esignAttendantTypes"
        label={t(translationPath + "esignAttendantType")}
        size="small"
        options={insuranceTypes}
        SearchAsYouTypeParams={handleSetSearchBy}
      />
    </Grid>
  );
});
